<div class="certificate-traceability">
    <h2>{{ 'trazabilidadCertificado.title' | translate }}</h2>

    <div class="filters-info" *ngIf="filtersVisible">{{ 'global.infoRequired' | translate }}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{ 'show-warning': showWarning, 'show-error': showError }">
            <div class="entry-single">
                <label>{{ 'global.certificadoNum' | translate }} *</label>
                <input style="max-width: 20rem;" type="text" formControlName="numCertificado">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{ 'showFilters': filtersVisible }"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{ 'global.filtros.filtrar' | translate }}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{ 'showFilters': filtersVisible }"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{ 'global.filtros.cerrar' | translate }}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{ 'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm() }" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{ 'global.filtros.limpiar' | translate }}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{ 'showFilters': filtersVisible }"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{ 'global.filtros.aplicar' | translate }}
        </button>
    </section>

    <section class="report" *ngIf="trazabilidadCertificado">
        <figure class="logo">
            <img src="assets/img/logo_marca_horizontal02.png" alt="Gesvatec">
        </figure>
        <div class="title-group">
            <h3>{{ 'trazabilidadCertificado.report.title' | translate }}</h3>
            <p>{{ 'trazabilidadCertificado.report.certificado' | translate }}: {{ trazabilidadCertificado.nCertificadoExpedicion }}</p>
        </div>

        <app-stepper 
            [steps]="steps" [iconsClassName]="icons" [allActive]="true"
            [heightToAdd]="blockchainInfoHeight" [sectionPosition]="parentPosition" [accordionAction]="blockchainAction">
            <!-- Cultivos -->
            <div data-step="1">
                <div class="data-group">
                    <p>{{ 'global.producto' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoCultivos_Producto }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'global.denominacion' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoCultivos_Denominacion }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="string">{{ 'global.codigoCultivo' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.provincia' | translate }}</th>
                                    <th class="string">{{ 'global.pais' | translate }}</th>
                                    <th class="string">{{ 'global.productor' | translate }}</th>
                                    <th class="number">{{ 'global.superficie' | translate }}</th>
                                    <th class="number">{{ 'global.plantas' | translate }}</th>
                                    <th class="number">{{ 'global.aforoKg' | translate }}</th>
                                    <!-- icon también al final en lugar de actions por el ancho -->
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let cultivo of trazabilidadCertificado.procesoCultivos; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="string">{{ cultivo.codigoCultivo }}</td>
                                    <td class="string">{{ cultivo.finca }}</td>
                                    <td class="string">{{ cultivo.municipio }}</td>
                                    <td class="string">{{ cultivo.provincia }}</td>
                                    <td class="string">{{ cultivo.pais }}</td>
                                    <td class="string">{{ cultivo.productor }}</td>
                                    <td class="number">{{ (cultivo.superficie | number : '1.0-2' : defaultLanguage) || 0 }} ha</td>
                                    <td class="number">{{ cultivo.plantas | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="number">{{ cultivo.aforo | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!trazabilidadCertificado.procesoCultivos || 
                                (trazabilidadCertificado.procesoCultivos && trazabilidadCertificado.procesoCultivos.length < 1)">
                                <tr>
                                    <td colspan="11">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Designaciones -->
            <div data-step="2">
                <div class="table-wrapper table-wrapper-traza-cert" style="margin-top: unset;">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="date">{{ 'global.fecha.designacion' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.productor' | translate }}</th>
                                    <th class="string">{{ 'global.etiquetador' | translate }}</th>
                                    <th class="number">{{ 'global.designadoKg' | translate }}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let designacion of trazabilidadCertificado.procesoDesignaciones; let i=index">
                                <tr>
                                    <td class="date">{{ designacion.fechaDesignacion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                    <td class="string">{{ designacion.finca }}</td>
                                    <td class="string">{{ designacion.municipio }}</td>
                                    <td class="string">{{ designacion.productor }}</td>
                                    <td class="string">{{ designacion.etiquetador }}</td>
                                    <td class="number">{{ (designacion.designadoKg | number : '1.0-2' : defaultLanguage) || 0 }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!trazabilidadCertificado.procesoDesignaciones || 
                                (trazabilidadCertificado.procesoDesignaciones && trazabilidadCertificado.procesoDesignaciones.length < 1)">
                                <tr>
                                    <td colspan="7">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Confecciones -->
            <div data-step="3">
                <div class="data-group">
                    <p>{{ 'trazabilidadCertificado.report.almacen' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoConfeccion_AlmacenEnvasado }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidadCertificado.report.direccionAlmacen' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoConfeccion_AlmacenDireccion }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="date">{{ 'global.fecha.confeccion' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.productor' | translate }}</th>
                                    <th class="string">{{ 'global.confeccion' | translate }}</th>
                                    <th class="string">{{ 'global.type' | translate }}</th>
                                    <th class="number">{{ 'global.unidades' | translate }}</th>
                                    <th class="number">{{ 'global.confeccionadoKg' | translate }}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let confeccion of trazabilidadCertificado.procesoConfeccion; let i=index">
                                <tr>
                                    <td class="date">{{ confeccion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                    <td class="string">{{ confeccion.finca }}</td>
                                    <td class="string">{{ confeccion.municipio }}</td>
                                    <td class="string">{{ confeccion.productor }}</td>
                                    <td class="string">{{ confeccion.confeccion }}</td>
                                    <td class="string">{{ confeccion.tipo === 1 ? ('global.caja' | translate) :
                                        confeccion.tipo === 2 ? ('global.pallet' | translate) : '' }}</td>
                                    <td class="number">{{ confeccion.numEtqImpEfectivas | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="number">{{ (confeccion.sumKilosEfectivos | number : '1.0-2' : defaultLanguage) || 0 }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!trazabilidadCertificado.procesoConfeccion || 
                                (trazabilidadCertificado.procesoConfeccion && trazabilidadCertificado.procesoConfeccion.length < 1)">
                                <tr>
                                    <td colspan="9">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Expediciones -->
            <div data-step="4">
                <div class="data-group">
                    <p>{{ 'global.fecha.expedicion' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoExpediciones_FechaExpedicion | date: 'shortDate' : undefined : defaultLanguage }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidadCertificado.report.paisOrigen' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoExpediciones_Pais }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidadCertificado.report.vehicle' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoExpediciones_Vehiculo }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidadCertificado.report.cajasTotal' | translate }}:</p>
                    <p>{{ trazabilidadCertificado.procesoExpediciones_TotalCajas | number : '1.0-0' : defaultLanguage }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="string">{{ 'global.lote' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.provincia' | translate }}</th>
                                    <th class="number">{{ 'global.cajas' | translate }}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let expedicion of trazabilidadCertificado.procesoExpediciones; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="string">{{ expedicion.lote }}</td>
                                    <td class="string">{{ expedicion.finca }}</td>
                                    <td class="string">{{ expedicion.municipio }}</td>
                                    <td class="string">{{ expedicion.provincia }}</td>
                                    <td class="number">{{ expedicion.cajas | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!trazabilidadCertificado.procesoExpediciones || 
                                (trazabilidadCertificado.procesoExpediciones && trazabilidadCertificado.procesoExpediciones.length < 1)">
                                <tr>
                                    <td colspan="8">
                                        {{ 'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <!-- Desplegable blockchain -->
                <div *ngIf="trazabilidadCertificado?.certificadoExpedicionVechain?.existeRegBlockchain" class="blockchain-container blockchain-container-expediciones collapsed">
                    <div class="blockchain-title blockchain-title-expediciones" (click)="showOrHideData(3, 'expediciones')">
                        <i class="fas fa-circle-nodes"></i>
                        <h4>{{'global.blockchain.verRastreo' | translate}}</h4>
                        <i class="fas fa-angle-down blockchain-arrow blockchain-arrow-expediciones"></i>
                    </div>
                    <div class="blockchain-content blockchain-content-expediciones">
                        <div class="data-blockchain link">
                            <p>{{'global.blockchain.informacion.blockchain' | translate}}</p>
                            <span>
                                {{ trazabilidadCertificado?.certificadoExpedicionVechain?.blockchain }}
                                <a
                                    [href]="getBlockchainLink(trazabilidadCertificado?.certificadoExpedicionVechain?.txId)" target="_blank">
                                        ({{'global.blockchain.informacion.enlace' | translate}})</a>
                            </span>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.fechaRegistro' | translate}}</p>
                            <p>{{ trazabilidadCertificado?.certificadoExpedicionVechain?.fechaRegistro | date: 'shortDate' : undefined : defaultLanguage }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{ 'global.blockchain.informacion.input' | translate}}</p>
                            <p>{{ trazabilidadCertificado?.certificadoExpedicionVechain?.textoHash }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.hash' | translate}}</p>
                            <p>{{ trazabilidadCertificado?.certificadoExpedicionVechain?.hash }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.idCripto' | translate}}</p>
                            <p>{{ trazabilidadCertificado?.certificadoExpedicionVechain?.txId }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </app-stepper>
    </section>

    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showWarning=showError=$event;">
    </app-toast>
</div>